<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>組織</h5>
      </div>
      <div class="col-3">
        <button id="createUserBtn" type="button" class="btn-sm btn-outline-info" v-on:click="create">組織を追加する</button>      
      </div>
    </div>

    <div class="row">
      <div class="col-1">
      </div>
      <div class="col-3">
        <div class="form-group">
        <select class="form-control" v-model="historyId" v-on:change="selectHistory">
          <option v-for="option in historyOptions" v-bind:value="option.id" v-bind:key="option.id">
            {{ option.startAt }} 〜 {{ option.endAt }}
          </option>
        </select>     
        </div>   
      </div>
    </div>
    <div id="main" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <table class="table table-dark table-sm table-hover table-borderless">
          <thead>
            <tr>
              <th scope="col" style="width:70px">#</th>
              <th scope="col">組織名称</th>
              <th scope="col" style="width:150px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(organization, index) in organizations" v-bind:key="organization.id">
              <th scope="row">{{ index + 1 }}</th>
              <td>{{ organization.displayName }}</td>
              <td>
                <button v-if="currentHistoryId == historyId" type="button" class="btn-sm btn-light" v-on:click="modify(organization.id)">編集する</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-3">
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Index',
  mixins: [sessions,path,headers],
  props: ['realms'],
  data: function(){
    return {
      organizations: [],
      historyId: 0,
      currentHistoryId: 0,
      historyOptions: [],
      message: '',
      space: '　'
    }
  },
  mounted() {
    if(this.$store.getters.hospital.id !== 0){
      this.getHistoryList()
    }
    this.$store.watch(
      (state, getters) => getters.hospital,
      (newValue, oldValue) => {
        if (newValue.id != oldValue.id) {
          this.getHistoryList()
        }
      }
    )
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0
    }
  },
  methods: {
    create() {
      var historyId = this.historyId
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/organization/create/'+historyId))
    },
    modify(id) {
      var historyId = this.historyId
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/organization/modify/'+historyId+'/'+id))
    },
    search() {
      this.$cognito.isAuthenticated().then((session) => {
      if(session){
        var accessToken = this.getAccessToken(this.$cognito,session)
        var hospitalId = this.$store.getters.hospital.id
        var historyId = this.historyId
        axios.post("/api/organization/management/list/",{
          hospitalId: hospitalId,
          historyId: historyId
        },{
          headers: this.headers(accessToken)
        }).then(response => {
          this.organizations = response.data.data.organizations.map(element => {
            var name = element.organizationName
            element.displayName = this.space.repeat(element.hierarchyNo) + name
            return element
          })
        }).catch(err => {
          this.message = err.message
        })
      } else {
        this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
      }}).catch((err) => {
        this.message = err.message
      })
    },
    getHistoryList() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          axios.get("/api/organization/management/historylist/" + hospitalId, {
            headers: this.headers(accessToken)
          }).then(response => {
            this.historyOptions = response.data.data.organizations
            if (this.historyOptions.length > 0 ){
              this.currentHistoryId = response.data.data.historyId
              this.historyId = this.currentHistoryId

              var selected = this.historyOptions.filter((element)=>{
                return element.id === this.historyId
              })
              if (selected.length == 1){
                this.$store.commit('organization',{
                  startAt: selected[0].startAt,
                  historyId: this.historyId
                })
              }
              this.search()
            } else {
              this.organizations = []
              this.currentHistoryId = 0
              this.historyId = 0
            }
          }).catch(err => {
            this.message = err.message
          })
      } else {
        this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
      }}).catch((err) => {
        this.message = err.message
      })
    },
    selectHistory() {
      this.search()
    } 
  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#main {
  height: 100%;
}
#createUserBtn {
  float:right;
}
.btn-sm{
  margin-left: 5px;
}
.search-solid{
  cursor: pointer;
  height: 18px;
  width: 18px;
}
.sort-solid{
  height: 25px;
  width: 25px;
  margin-right: 10px;
}
#sort-select{
  width: 70%;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>